import { inject, injectable } from "@launchtray/tsyringe-async";
import { PreloaderModel } from "../models/PreloaderModel";
import { PromiseCompletionSource, SceneManager } from "scene-manager";
import { InjectableFactories, MenuFactory } from "../../../composition/InjectableFactories";

@injectable()
export class PreloaderController {
    public constructor(
        private readonly preloaderModel: PreloaderModel,
        private readonly sceneManager: SceneManager,
        @inject(InjectableFactories.MenuFactory)
        private readonly menuFactory: MenuFactory
    ) {
    }

    public async startPreloading(): Promise<void> {
        await this.preloaderModel.startPreloadingPackages();
    }

    public async showMenu(operationControls: PromiseCompletionSource<void>): Promise<void> {
        const menuScene = await this.menuFactory();
        operationControls.complete();
        this.sceneManager.showViewableAsync(menuScene);
    }
}